import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { PRODUCT_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { SpecimenListPage } from '@/features/product/pages/SpecimenListPage';
import { specimenListSearchSchema } from '@/features/product/types/product.types';

export const Route = createFileRoute('/_auth/product/specimens')({
  beforeLoad: () => requirePermission(PRODUCT_PERMISSIONS.SPECIMEN_LIST_VIEW),
  validateSearch: specimenListSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Specimen List">
      <Suspense fallback={<PageLoader />}>
        <SpecimenListPage routeId="specimens" readOnly={false} shouldHideEarlySpecimens={false} />
      </Suspense>
    </ErrorBoundary>
  ),
});
